import React, { useEffect, useState } from "react";

function ExpandDiv({
  children,
  title,
  progressBar,
  expandIcon,
  collapseIcon,
  expandStatus,
  tooltip,
  preserveChildren,
  expandHandler,
  ...rest
}) {
  const [expanded, setExpanded] = useState(expandStatus);
  const expIcon = expandIcon ? expandIcon : "fas fa-chevron-down";
  const colIcon = collapseIcon ? collapseIcon : "fas fa-chevron-up";

  useEffect(() => {
    setExpanded(expandStatus);
  }, [expandStatus]);

  return (
    <div {...rest}>
      <div
        onClick={() => {
          const newValue = !expanded;
          setExpanded(newValue);
          expandHandler?.(newValue);
        }}
        title={tooltip}
      >
        {!progressBar && (
          <>
            <div className="h4">
              <i
                title={expanded ? "Collapse" : "Expand"}
                className={
                  expanded
                    ? `${colIcon} p-1 text-primary`
                    : `${expIcon} p-1 text-primary`
                }
                onClick={() => setExpanded(!expanded)}
              ></i>
              {title}
            </div>
          </>
        )}
        {progressBar && (
          <>
            <div className="row">
              <div className="col-8">
                <span className="h4">
                  <i
                    title={expanded ? "Collapse" : "Expand"}
                    className={
                      expanded
                        ? `${colIcon} p-1 text-primary`
                        : `${expIcon} p-1 text-primary`
                    }
                    onClick={() => setExpanded(!expanded)}
                  ></i>
                  {title}
                </span>
              </div>
              <div className="col-3">{progressBar}</div>
            </div>
          </>
        )}
      </div>
      {preserveChildren ? (
        <span className={`${!expanded ? "d-none" : ""}`}>{children}</span>
      ) : expanded ? (
        children
      ) : null}
    </div>
  );
}

export default ExpandDiv;
